import React from "react";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { maxWidth } from "@mui/system";
import { Grid } from "@mui/material";
import CryptoJS from 'crypto-js';

const ChangePay = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const { dataPolicies } = location.state || {}; 

  console.log("dataPolicies:", dataPolicies);

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const getUserType = (username) => {
    if (!username) return false;
  
    if (/^[0-9]/.test(username)) {
      return true;
    }
  
    if (/^[A-Za-z]/.test(username)) {
      return false;
    }
  
    return true;
  };
  
  const username = localStorage.getItem("customer_id"); 
  const age = Number(localStorage.getItem("age"));
  const decryptedUser = decryptCardNumber(username, process.env.REACT_APP_ENCRYPT_DATA);
  const isPromptPayDisabled = age < 20 || !getUserType(decryptedUser);

  const goToEditInfoChannel = (channel) => {
    navigate(`/ChangeChannel?channelType=${channel}`, {
      state: { dataPolicies },
    });
    
  };

  const goBack = () => {
    navigate(`/personal`);
  };


  return (
    <>
      <Header_Home />
      <Header title="เปลี่ยนบัญชีธนาคาร" />
      <div className="containers px-4 pt-5 mt-4">
        <div
          style={{ paddingBottom: 20 }}
          className="card-change-pay big-frame-change-pay"
        >
          <div className="d-flex px-3 pt-3 pb-3" style={{ paddingLeft: "60px" }}>
            <h2 className="font-size-title">ช่องทางการรับเงิน</h2>
          </div>
          <hr
            className="mx-2"
            style={{ margin: "0px 0px 15px 0px", border: "solid 1px" }}
          />
          {/* <div className="d-flex flex-row" style={{ paddingLeft: "30px" }}>
            <div
              onClick={() => goToEditInfoChannel("bank")}
              style={{ maxWidth: "250px" }}
              className="card-service-change-pay d-flex flex-column text-center align-items-center justify-content-center align-content-center"
            >
              <img
                src={require("../../images/BankCards.svg").default}
                alt="mySvgImage"
                className="img-service-payment-change-pay"
              />
              <p className="fontSizeCard-Change-pay">บัญชีธนาคาร</p>
            </div>
          </div> */}
          <div className="d-flex flex-row justify-content-evenly">
            <div
              onClick={() => goToEditInfoChannel("bank")}
              style={{ maxWidth: "250px" }}
              className="card-service-change-pay d-flex flex-column text-center align-items-center justify-content-center align-content-center"
            >
              <img
                src={require("../../images/BankCards.svg").default}
                alt="mySvgImage"
                className="img-service-payment-change-pay"
              />
              <p className="fontSizeCard-Change-pay">บัญชีธนาคาร</p>
            </div>

            <div
              onClick={
                isPromptPayDisabled
                  ? undefined
                  : () => goToEditInfoChannel("promptpay")
              }
              style={{
                maxWidth: "250px",
                opacity: isPromptPayDisabled ? 0.5 : 1,
                cursor: isPromptPayDisabled ? "not-allowed" : "pointer",
              }}
              className="card-service-change-pay d-flex flex-column text-center align-items-center justify-content-center align-content-center"
              aria-disabled={isPromptPayDisabled}
              tabIndex={isPromptPayDisabled ? -1 : 0}
              title={
                isPromptPayDisabled ? "ต้องอายุอย่างน้อย 20 ปี" : undefined
              }
            >
              <img
                src={require("../../images/promptpay.png")}
                height={30}
                width={35}
                alt="mySvgImage"
                className="img-service-payment-change-pay-promtpay"
              />
              <p className="fontSizeCard-Change-pay">บัญชีพร้อมเพย์</p>
            </div>
          </div>
          <div className="d-flex mt-4 mb-1" style={{ paddingLeft: "17%" }}>
            <p style={{ color: "red", fontFamily: "Prompt-Thin", fontSize: "14px" }}>
              **การทำรายการในครั้งนี้ จะมีผลต่อการรับเงินคืนของทุกกรมธรรม์
            </p>
          </div>
        </div>
        {/* <Row className="d-flex flex-column mt-5 mb-5">
          <Col className="d-flex justify-content-center px-5">
            <button
              onClick={goBack}
              className="btn-checkout-back w-100 p-2 bold"
            >
              ย้อนกลับ
            </button>
          </Col>
        </Row> */}
        <Grid
          container
          spacing={1}
          className="justify-content-center flex-wrap"
        >
          <Grid item xs={12} sm={6}>
            <button
              onClick={goBack}
              className="btn-checkout-back w-100 p-2 bold"
            >
              ย้อนกลับ
            </button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ChangePay;
